import React, { useState } from 'react';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import { useCurrentUserContext } from 'features/user/contexts/user-provider';
import getUserMenus from 'common/utils/get-user-menus';
import { MenuItem } from '@mui/material';
import Typography from '@mui/material/Typography';
import $t from 'translation';
import styles from './styles';
import { useNavigate } from 'react-router-dom';
// import HeaderUser from 'components/header-user'

const Setting = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { logout, authorized } = useCurrentUserContext();
  const isMenuOpen = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleOpenUserMenu = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseUserMenu = menu => {
    setAnchorEl(null);

    if (menu?.key === 'logout') {
      logout();
    }
    if (menu?.to) {
      navigate(menu?.to);
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={styles.box}>
      <div style={styles.user} onClick={handleOpenUserMenu}>
        {/* <HeaderUser user={user}/> */}
        <IconButton sx={styles.iconButton} data-testId='avatar'>
          <Avatar />
        </IconButton>
      </div>
      <Menu
        sx={styles.menu}
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        keepMounted
      >
        {getUserMenus(authorized).map(menu => (
          <MenuItem
            data-testid={menu.key}
            key={menu.key}
            onClick={() => handleCloseUserMenu(menu)}
          >
            <Typography textAlign='center'>{$t(menu.label)}</Typography>
          </MenuItem>
        ))}
      </Menu>
    </Box>
  );
};

export default Setting;
